import { Col } from 'antd';
import styled from 'styled-components';
import { LEFT_COL_WIDTH } from 'utils/constants';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';

export const MapCol = styled(Col)`
  margin-left: 12px;
  height: calc(100vh - 170px);
`;

export const LeftCol = styled(Col)`
  max-height: calc(100vh - 170px);
  padding-bottom: 6px;
  min-width: ${LEFT_COL_WIDTH};

  ${cssMediaBreakpoints.mobileOrTablet} {
    max-height: unset;
    min-width: 100%;
  }
`;
